import "../ExamChoiceByGender/ExamChoiceByGender.css";
import NavBar from '../../Layouts/NavBar';
import ExamChoiceByPhysicalSale from './ExamChoiceByPhysicalSale';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import UserInfoProvider from '../../Context/UserInfoContext';
import MedicalContextProvider from '../../Context/MedicalContext';
import PacksProvider from "../../Context/PacksContext";
import Footer from '../../Layouts/Footer';

function ExamChoiceByPhysicalSaleRoute() {
    
    return (
        <UserInfoProvider>
            <MedicalContextProvider>
            <PacksProvider>
       <BrowserView>
            <div className="ExamChoiceByPhysicalSaleRoutePage">
                <div className="ExamChoiceByPhysicalSaleRouteNavBar">      
                    <NavBar/>
                </div>
                <div className="ExamChoiceByPhysicalSaleRoute">
                    <ExamChoiceByPhysicalSale/>
                </div>
                <div className="ExamChoiceByPhysicalSaleContact">
                    <Footer/>
                </div>
            </div>
       </BrowserView>
        <MobileView>
            <div className="ExamChoiceByPhysicalSaleRouteNavBar">      
                <NavBar/>
            </div>
            <div className="ExamChoiceByPhysicalSaleRoute">
                <ExamChoiceByPhysicalSale/>
            </div>
            <div className="ExamChoiceByPhysicalSaleContact">
                <Footer/>
            </div>
</MobileView>
</PacksProvider>
</MedicalContextProvider>
       </UserInfoProvider>
    );
}

export default ExamChoiceByPhysicalSaleRoute;